import { Button } from "antd";

const colors = {
  brand: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5", // teal.300
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
  },

  /* Light Theme */
  light: {
    background: "#F7FAFC",
    surface: "#FFFFFF",
    card: "#FFFFFF",
    //Login Page
    login_bg: "#FFFFFF",
    login_label_input: "#FFFFFF",
    login_label_input_base: "#f6fafd",
    login_box_shadow: "0 0 30px rgba(0,0,0,0.15)",
    //Button
    button_teal_color: "#FFFFFF",
    button_teal_bg: "#4FD1C5",
    button_teal_hover: "#319795",
    button_gray_color: "#000000",
    button_gray_bg: "#edf2f6",
    button_gray_hover: "#d2dfe4",
    button_csr_unselected_bg: "#FFFFFF",
    button_csr_border_color: "#ececec",
    //Navbar
    navbar_filter: "none",
    navbar_border_color: "rgba(255,255,255,0.35)",
    navbar_main_text: "#50555b",
    nabar_secondry_text: "#b5c0cd",
    navbar_shadow: "0px 7px 23px rgba(0, 0, 0, 0.05)",
    navbar_bg:
      "linear-gradient(112.83deg, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0.45) 110.84%)",
    navbar_logout_button_bg: "#FFEBEE",
    navbar_logout_button_color: "0.5px solid #E57373",
    navbar_logout_button_icon: "#E57373",
    navbar_logout_button_shadow: "0 0 8px rgba(0,0,0,.12)",
    //InfoPanel
    infopanel_avatar_bg: "#B2F5EA",
    infopanel_avatar_color: "#2C7A7B",
    infopanel_card: "#FFFFFF",
    infopanel_role_text: "#90A4AE",
    infopanel_data_text: "#4c4c4c",
    infopanel_theme_bg: "#FFFFFF",
    //Sidebar
    sidebar: "#4FD1C5",
    sidebar_select_div: "#f6fafd",
    sidebar_hover: "#139693",
    sidebar_select_icon_bg: "#4FD1C5",
    sidebar_select_icon_color: "#FFFFFF",
    sidebar_unselect_icon_bg: "#FFFFFF",
    sidebar_unselect_icon_color: "#4FD1C5",
    sidebar_select_text: "#000000",
    sidebar_unselect_text: "#FFFFFF",
    sidebar_seprator_bg:
      "linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #E0E1E2 49.52%, rgba(224, 225, 226, 0) 100%)",
    //Box Panel
    boxpanel_style_color:
      "linear-gradient(112.83deg, rgba(255,255,255,0.82) 0%, rgba(255,255,255,1) 110.84%)",
    boxpanel_style_shadow: "0px 7px 23px rgba(0,0,0,0.05)",
    //Input
    input_label_bg: "#FFFFFF",
    input_label_color: "#a1a1aa",
    input_border_color: "#e2e8f0",
    input_searchbar_bg: "#FFFFFF",
    input_disabled_bg: "#F5F5F5",
    input_disabled_text: "#A0AEC0",
    input_disabled_label: "#A0AEC0",
    input_readonly_bg: "#eaeaea",
    input_readonly_text: "#6c6c6c",
    input_readonly_label: "#718096",
    input_readonly_border: "#E2E8F0",
    // Input Search
    input_search_bg: "#FFFFFF",
    input_search_text: "#FFFFFF",
    input_search_placeholder: "#A0AEC0",
    input_search_border: "#E2E8F0",
    input_search_icon: "#FFFFFF",

    input_search_button_bg: "#4FD1C5",
    input_search_button_border: "#4FD1C5",
    input_search_button_icon: "#FFFFFF",

    input_search_button_hover_bg: "#38B2AC",
    input_search_button_hover_border: "#38B2AC",
    input_search_button_hover_icon: "#FFFFFF",

    input_search_button_disabled_bg: "#E2E8F0",
    input_search_button_disabled_border: "#CBD5E0",
    input_search_button_disabled_icon: "#A0AEC0",
    //Table
    table_bg: "#FFFFFF",
    table_header_bg: "#FFFFFF",
    table_header_text_color: "#000000",
    table_border_color: "#f4f4f4",
    table_body_text_color: "#000000",
    table_body_second_row: "#f0f0f0",
    table_row_hover: "#e6fffd",
    table_selected_bg: "#E6FFFD",
    table_selected_hover_bg: "#D3FBF8",
    table_addkala_bg: "#EDF2F7",
    // Pagination
    pagination_bg: "#FFFFFF",
    pagination_border_color: "#E2E8F0",
    pagination_text_color: "#4A5568",
    pagination_hover_bg: "#F7FAFC",
    pagination_hover_text_color: "#2D3748",
    pagination_hover_border_color: "#dcd6dc",
    pagination_active_bg: "#4FD1C5",
    pagination_active_text_color: "#FFFFFF",
    pagination_disabled_text_color: "#A0AEC0",
    // Pagination Select Dropdown
    pagination_select_text_color: "#000000",
    pagination_select_hover_text_color: "#2D3748",
    pagination_select_selected_text_color: "#FFFFFF",
    pagination_select_selected_bg: "#4FD1C5",
    // Table Scrollbar
    table_scrollbar_bg: "#F1F5F9",
    table_scrollbar_thumb: "#c7dae5",
    table_scrollbar_thumb_hover: "#94A3B8",
    // Table Status Rows
    table_row_ebtali: "#F9F6E2",
    table_row_eslahi: "#e6e7f3",
    table_row_return: "#E6CDB7",
    table_row_success: "#E7FBDE",
    table_row_failed: "#F2BEBE",
    table_row_inprocess: "#DAEFF6",
    table_row_alter: "#F8F8F8",
    //Table Expandable button
    table_expand_bg: "#FFFFFF",
    table_expand_border: "#D9D9D9",
    table_expand_icon: "#595959",
    table_expand_hover_bg: "#F5F5F5",
    table_expand_hover_border: "#BFBFBF",
    table_expand_hover_icon: "#262626",
    table_expand_active_bg: "#FFFFFF",
    table_expand_active_border: "#D9D9D9",
    table_expand_active_icon: "#595959",
    //Tabel Status Color
    status_processing: "#0548B3",
    status_success: "#057A13",
    status_failed: "#FF0303",
    status_warning: "#F7A307",
    status_not_found: "#D6B406",
    status_connection_error: "#ED6707",
    status_default: "#808080",
    // Table Filter
    table_filter_icon: "#6B7280",
    table_filter_hover: "#319795",
    table_filter_active: "#2C7A7B",

    table_filter_dropdown_bg: "#FFFFFF",
    table_filter_dropdown_border: "#E2E8F0",
    table_filter_dropdown_text: "#1A202C",
    table_filter_dropdown_hover: "#F7FAFC",
    table_filter_dropdown_selected_bg: "#E6FFFA",
    table_filter_dropdown_selected_text: "#1A202C",
    table_filter_confirm_text: "#FFFFFF",
    table_filter_reset_text: "#319795",
    table_filter_reset_hover_text: "#2C7A7B",
    table_filter_reset_disabled_text: "#A0AEC0",
    // Modal
    modal_bg: "#FFFFFF",
    modal_border: "#E2E8F0",
    modal_text: "#1A202C",
    modal_overlay: "rgba(0,0,0,0.45)",
    // Menu
    menu_bg: "#FFFFFF",
    menu_text: "#1A202C",
    menu_border: "#E2E8F0",
    menu_hover_bg: "#e9e9e9",
    menu_hover_text: "#1A202C",
    menu_divider: "#E2E8F0",
    menu_group_text: "#718096",
    menu_disabled: "#A0AEC0",
    menu_sub_bg: "#FFFFFF",
    menu_sub_shadow: "inset 0 0 8px rgba(0,0,0,0.15)",
    //Clipboard
    clipboard_msg_bg: "#FFFFFF",
    clipboard_msg_color: "#000000",

    input: "#FFFFFF",
    inputBorder: "#E2E8F0",
    border: "#E2E8F0",
    divider: "#EDF2F7",
    text: "#1A202C",
    textSecondary: "#718096",
    textDisabled: "#A0AEC0",
    shadow: "rgba(15,23,42,.08)",
    //PopConfirm
    popconfirm_bg: "#FFFFFF",
    popconfirm_border: "#E2E8F0",
    popconfirm_title: "#1A202C",
    popconfirm_text: "#4A5568",
    popconfirm_icon: "#DD6B20",

    popconfirm_cancel_bg: "#FFFFFF",
    popconfirm_cancel_border: "#CBD5E0",
    popconfirm_cancel_text: "#1A202C",
    popconfirm_cancel_hover: "#F7FAFC",

    popconfirm_confirm_bg: "#4FD1C5",
    popconfirm_confirm_hover: "#38B2AC",
    popconfirm_confirm_text: "#FFFFFF",
    //Acordian
    acordian_bg: "#e5e5e5",
    acordian_border_color: "#e5e5e5",
    //Dashboard
    dashboard_card_bg: "#fbfbfb",
    dashboard_inside_card_bg: "#FFFFFF",
    dashboard_red_icon_bg: "#fff5f5",
    dashboard_red_icon_color: "#dd4143",
    dashboard_green_icon_bg: "#e6fffa",
    dashboard_green_icon_color: "#4cd2c9",
    dashboard_card_desc_color: "#71717a",
    dashboard_card_title_color: "#2b6364",
    dashboard_filter_box_bg: "#FFFFFF",
    //Plans
 plan_none_bg: "linear-gradient(135deg, #fef2f2, #fee2e2)",
plan_none_color: "#dc2626",
plan_none_glow: "rgba(220, 38, 38, .3)",

    plan_trial_bg: "linear-gradient(135deg, #eef1f3, #dfe4e8)",
    plan_trial_color: "#4b5563",
    plan_trial_glow: "rgba(107,114,128,.3)",

    plan_plus_bg: "linear-gradient(135deg, #cffafe, #a5f3fc)",
    plan_plus_color: "#0e7490",
    plan_plus_glow: "rgba(6,182,212,.4)",

    plan_pro_bg: "linear-gradient(135deg, #f3e8ff, #e9d5ff)",
    plan_pro_color: "#7e22ce",
    plan_pro_glow: "rgba(147,51,234,.35)",
    //Plans Pricing
    pricing_page_bg: "#f2f6f6",
    pricing_card_bg: "#ffffff",
    pricing_card_border: "#e4ecec",
    pricing_card_border_featured: "#3fbdb0",

    pricing_text_primary: "#1e2b33",
    pricing_text_secondary: "#3d4d56",
    pricing_text_muted: "#6b7c85",
    pricing_text_faint: "#9fb0b8",

    pricing_surface_mint: "#f4fbfa",
    pricing_surface_teal_tint: "#e6f8f5",

    pricing_accent_teal_light: "#4fd1c5",
    pricing_accent_teal: "#3fbdb0",
    pricing_accent_teal_hover: "#2a9188",
    pricing_accent_teal_dark: "#1f7a72",

    pricing_enterprise_bg: "#1e2b33",
    pricing_enterprise_text: "#ffffff",
    pricing_enterprise_text_muted: "rgba(255,255,255,0.7)",
    pricing_enterprise_border: "rgba(255,255,255,0.12)",
    pricing_enterprise_dot: "#e8b84b",

    pricing_shine: "rgba(255,255,255,0.55)",
  },

  /*----------------------------------------------------------------- Dark Theme -------------------------------------------------------------------------- */
  dark: {
    background: "#2b2b2b",
    surface: "#4A4A4A",
    card: "#7b7b7b",
    //Login Page
    login_bg: "#353535",
    login_label_input: "#2b2b2b",
    login_label_input_base: "#2b2b2b",
    login_box_shadow: "0 0 30px rgba(0,0,0,0.6)",
    //Button
    button_teal_color: "#FFFFFF",
    button_teal_bg: "#285d61",
    button_teal_hover: "#377579",
    button_gray_color: "#cecece",
    button_gray_bg: "#454545",
    button_gray_hover: "#6a6a6a",
    button_csr_unselected_bg: "#2b2b2b",
    button_csr_border_color: "#ececec",
    //Navbar
    navbar_filter: "drop-shadow(0px 7px 23px rgba(0, 0, 0, 0.05))",
    navbar_border_color: "rgba(255,255,255,0.08)",
    navbar_main_text: "#e6e9f0",
    nabar_secondry_text: "#b7b7b7",
    navbar_shadow: "none",
    navbar_bg:
      "linear-gradient(112.83deg, rgba(49,49,49,0.72) 0%, rgba(66,66,66,0.55) 110.84%)",
    navbar_logout_button_bg: "#3C2420",
    navbar_logout_button_color: "0.5px solid #712B13",
    navbar_logout_button_icon: "#F0997B",
    navbar_logout_button_shadow: "0 0 10px rgba(0,0,0,0.3)",
    //InfoPanel
    infopanel_avatar_bg: "#2C7A7B",
    infopanel_avatar_color: "#B2F5EA",
    infopanel_card: "#2b2b2b",
    indopanel_role_text: "#90A4AE",
    infopanel_data_text: "#FFFFFF",
    infopanel_theme_bg: "#2b2b2b",
    //Sidebar
    sidebar: "#285d61",
    sidebar_select_div: "#2b2b2b",
    sidebar_hover: "#3d8589",
    sidebar_select_icon_bg: "#B2F5EA",
    sidebar_select_icon_color: "#2b2b2b",
    sidebar_unselect_icon_bg: "#2b2b2b",
    sidebar_unselect_icon_color: "#B2F5EA",
    sidebar_select_text: "#FFFFFF",
    sidebar_unselect_text: "#FFFFFF",
    sidebar_seprator_bg:
      "linear-gradient(90deg, rgba(224, 225, 226, 0) 0%, #E0E1E2 49.52%, rgba(224, 225, 226, 0) 100%)",
    //Box Panel
    boxpanel_style_color:
      "linear-gradient(112.83deg, rgba(53,53,53,0.95) 0%, rgba(53,53,53,1) 110.84%)",
    boxpanel_style_shadow: "0px 12px 32px rgba(0,0,0,0.35)",
    //Input
    input_label_bg: "#353535",
    input_label_color: "#a1a1aa",
    input_border_color: "#5d5d60",
    input_searchbar_bg: "#353535",
    input_disabled_bg: "#404040",
    input_disabled_text: "#8F8F8F",
    input_disabled_label: "#8F8F8F",
    input_readonly_bg: "#4f4f4f",
    input_readonly_text: "#d0d0d0",
    input_readonly_label: "#A0AEC0",
    input_readonly_border: "#5C5C5C",
    // Input Search
    input_search_bg: "#353535",
    input_search_text: "#FFFFFF",
    input_search_placeholder: "#9CA3AF",
    input_search_border: "#5C5C5C",
    input_search_icon: "#FFFFFF",

    input_search_button_bg: "#285d61",
    input_search_button_border: "#285d61",
    input_search_button_icon: "#FFFFFF",

    input_search_button_hover_bg: "#34777B",
    input_search_button_hover_border: "#34777B",
    input_search_button_hover_icon: "#FFFFFF",

    input_search_button_disabled_bg: "#454545",
    input_search_button_disabled_border: "#5C5C5C",
    input_search_button_disabled_icon: "#8A8A8A",
    //Table
    table_bg: "#353535",
    table_header_bg: "#353535",
    table_header_text_color: "#FFFFFF",
    table_border_color: "#5c5c5c",
    table_body_text_color: "#FFFFFF",
    table_body_second_row: "#434343",
    table_row_hover: "#30535d",
    table_selected_bg: "#2F4F57",
    table_selected_hover_bg: "#39626D",
    table_addkala_bg: "#535353",
    // Pagination
    pagination_bg: "#353535",
    pagination_border_color: "#5C5C5C",
    pagination_text_color: "#FFFFFF",
    pagination_hover_bg: "#434343",
    pagination_hover_text_color: "#FFFFFF",
    pagination_hover_border_color: "#676767",
    pagination_active_bg: "#B2F5EA",
    pagination_active_text_color: "#353535",
    pagination_disabled_text_color: "#7A7A7A",

    // Pagination Select Dropdown
    pagination_select_text_color: "#FFFFFF",
    pagination_select_hover_text_color: "#FFFFFF",
    pagination_select_selected_text_color: "#353535",
    pagination_select_selected_bg: "#B2F5EA",
    // Table Scrollbar
    table_scrollbar_bg: "#353535",
    table_scrollbar_thumb: "#5C5C5C",
    table_scrollbar_thumb_hover: "#7A7A7A",
    input: "#565656",
    inputBorder: "#707070",
    // Table Status Rows
    table_row_ebtali: "#5f4d23",
    table_row_eslahi: "#364175",
    table_row_return: "#7A5A40",
    table_row_success: "#253A29",
    table_row_failed: "#582A28",
    table_row_inprocess: "#46758C",
    table_row_alter: "#4C4C4C",
    // Table Filter
    table_filter_icon: "#BDBDBD",
    table_filter_hover: "#81E5D9",
    table_filter_active: "#B2F5EA",

    table_filter_dropdown_bg: "#353535",
    table_filter_dropdown_border: "#5C5C5C",
    table_filter_dropdown_text: "#FFFFFF",
    table_filter_dropdown_hover: "#4A4A4A",
    table_filter_dropdown_selected_bg: "#285D61",
    table_filter_dropdown_selected_text: "#FFFFFF",
    table_filter_confirm_text: "#353535",
    table_filter_reset_text: "#81E6D9",
    table_filter_reset_hover_text: "#B2F5EA",
    table_filter_reset_disabled_text: "#6B7280",
    //Table Expandable button
    table_expand_bg: "#454545",
    table_expand_border: "#666666",
    table_expand_icon: "#FFFFFF",
    table_expand_hover_bg: "#555555",
    table_expand_hover_border: "#7A7A7A",
    table_expand_hover_icon: "#FFFFFF",
    table_expand_active_bg: "#454545",
    table_expand_active_border: "#666666",
    table_expand_active_icon: "#FFFFFF",
    //Tabel Status Color
    status_processing: "#A3D8FF",
    status_success: "#B9F6CA",
    status_failed: "#FECACA",
    status_warning: "#FDE68A",
    status_not_found: "#FEF3A0",
    status_connection_error: "#FDBA74",
    status_default: "#d9d9d9",
    // Modal
    modal_bg: "#353535",
    modal_border: "#5C5C5C",
    modal_text: "#F7FAFC",
    modal_overlay: "rgba(0,0,0,0.70)",
    // Menu
    menu_bg: "#353535",
    menu_text: "#F7FAFC",
    menu_border: "#5C5C5C",
    menu_hover_bg: "#4A4A4A",
    menu_hover_text: "#FFFFFF",
    menu_divider: "#5C5C5C",
    menu_group_text: "#BDBDBD",
    menu_disabled: "#808080",
    menu_sub_bg: "#353535",
    menu_sub_shadow: "inset 0 0 8px rgba(0,0,0,0.35)",
    //Clipboard
    clipboard_msg_bg: "#353535",
    clipboard_msg_color: "#FFFFFF",

    border: "#666666",
    divider: "#5A5A5A",
    text: "#FFFFFF",
    textSecondary: "#CBD5E0",
    textDisabled: "#A0AEC0",
    shadow: "rgba(0,0,0,.35)",
    //PopConfirm
    popconfirm_bg: "#424242",
    popconfirm_border: "#5A5A5A",
    popconfirm_title: "#FFFFFF",
    popconfirm_text: "#E2E8F0",
    popconfirm_icon: "#F6AD55",

    popconfirm_cancel_bg: "#454545",
    popconfirm_cancel_border: "#666666",
    popconfirm_cancel_text: "#FFFFFF",
    popconfirm_cancel_hover: "#6a6a6a",

    popconfirm_confirm_bg: "#285d61",
    popconfirm_confirm_hover: "#377579",
    popconfirm_confirm_text: "#FFFFFF",
    //Acordian
    acordian_bg: "#3f3f3f",
    acordian_border_color: "#3f3f3f",
    //Dashboard
    dashboard_card_bg: "#2b2b2b",
    dashboard_inside_card_bg: "#343434",
    dashboard_red_icon_bg: "#dd4143",
    dashboard_red_icon_color: "#fff5f5",
    dashboard_green_icon_bg: "#2C7A7B",
    dashboard_green_icon_color: "#B2F5EA",
    dashboard_card_desc_color: "#e4e4e7",
    dashboard_card_title_color: "#36a19b",
    dashboard_filter_box_bg: "#2b2b2b",
    //Plans
plan_none_bg: "linear-gradient(135deg, #dc2626, #991b1b)",
plan_none_color: "#fef2f2",
plan_none_glow: "rgba(220, 38, 38, .45)",

    plan_trial_bg: "linear-gradient(135deg, #6b7280, #4b5563)",
    plan_trial_color: "#f1f2f4",
    plan_trial_glow: "rgba(107,114,128,.45)",

    plan_plus_bg: "linear-gradient(135deg, #06b6d4, #0891b2)",
    plan_plus_color: "#ecfeff",
    plan_plus_glow: "rgba(6,182,212,.55)",

    plan_pro_bg: "linear-gradient(135deg, #9333ea, #6d28d9)",
    plan_pro_color: "#f5f0fe",
    plan_pro_glow: "rgba(147,51,234,.55)",
    //Plans Pricing
    pricing_page_bg: "#212121",
    pricing_card_bg: "#2f2f2f",
    pricing_card_border: "rgba(255,255,255,0.08)",
    pricing_card_border_featured: "#4fd1c5",

    pricing_text_primary: "#eef2f2",
    pricing_text_secondary: "#c3ced1",
    pricing_text_muted: "#8fa0a4",
    pricing_text_faint: "#5f7276",

    pricing_surface_mint: "#242424",
    pricing_surface_teal_tint: "rgba(79,209,197,0.12)",

    pricing_accent_teal_light: "#5fe0d3",
    pricing_accent_teal: "#3fbdb0",
    pricing_accent_teal_hover: "#57cfc2",
    pricing_accent_teal_dark: "#7fe8db",

    pricing_enterprise_bg: "#0f1517",
    pricing_enterprise_text: "#f4f7f7",
    pricing_enterprise_text_muted: "rgba(255,255,255,0.65)",
    pricing_enterprise_border: "rgba(255,255,255,0.1)",
    pricing_enterprise_dot: "#f0c96e",

    pricing_shine: "rgba(255,255,255,0.15)",
  },

  success: {
    500: "#22C55E",
  },

  warning: {
    500: "#F59E0B",
  },

  danger: {
    500: "#EF4444",
  },

  info: {
    500: "#3B82F6",
  },
};

export default colors;
